const raw_rootpath = process.env.REACT_APP_ROOT_PATH ? process.env.REACT_APP_ROOT_PATH : '/';
export const rootpath = raw_rootpath.endsWith('/') ? raw_rootpath.substr(0, raw_rootpath.length-1) : raw_rootpath ;
